<!-- Module 3  -->
<template>
  <div class="mentee-feedback">
    <div>
      <feedback-title :time="appDetail.mentorResultTimeStr"></feedback-title>
      <div class="mentee-feedback-con">
        <Form ref="formValidate"
              :model="formValidate"
              :rules="ruleValidate">
          <FormItem label="To recap some of the highlights from today's meeting"
                    prop="highlights"
                    class="dis-30">
            <div class="mentee-feedback-editor">
              <editor v-model="formValidate.highlights"
                      :cache=false></editor>
            </div>
          </FormItem>
          <FormItem v-for="(items, index) in formValidate.projectInfo"
                    :key="index"
                    :label="`Essay 0${index+1}`"
                    :prop="'projectInfo.'+index"
                    class="dis-30"
                    :rules="[{ required: true, message: promptInput }]">
            <div class="delete"
                 v-if="index>0"
                 @click="handleDeleteEssay(index)"></div>
            <div class="mentee-feedback-editor">
              <editor v-model="formValidate.projectInfo[index]"
                      :cache=false></editor>
            </div>
          </FormItem>
          <div class="mentee-feedback-add dis-30"
               @click="handleAddEssay">Add more Essay</div>
          <FormItem label="Homework"
                    prop="homework"
                    class="dis-30">
            <div class="mentee-feedback-editor">
              <editor v-model="formValidate.homework"
                      :cache=false></editor>
            </div>
          </FormItem>
          <!-- v-if="appDetail.videoType === 'ZOOM'" -->
          <div class="mentee-feedback-time">
            <spend-time :appDetail="appDetail"
                        @on-detail="sendRemainTime"></spend-time>
            <FormItem label=""
                      prop="timeSpent"
                      :class="['dis-30',
                      errorMsg?'':'mentee-appointment-feedback-error-msg']"
                      :show-message="errorMsg">
              <Input placeholder="Please fill out positive integer number of minutes"
                     v-model="formValidate.timeSpent"
                     @on-change="handleSendChange">
              <span slot="append">mins</span>
              </Input>
            </FormItem>
            <div class="error-msg"
                 v-if="!errorMsg">You have exceeded the maximum time allowance of a module, your exceeded time will not be remunerated！</div>
            <spend-time-tips></spend-time-tips>
          </div>
          <div class="mentee-feedback-btn">
            <Button class="zlr-btn-primary"
                    :loading="isSub"
                    @click="handleSend">Send</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
// components
import Editor from '_c/editor/editor'
import SpendTime from './feedback-spent-time'
import FeedbackTitle from './feedback-title'
import { promptInput } from '@/constant'
import { validateNumber } from '@/libs/validator'
import errorMixins from './mixins/feedback-error.js'
import SpendTimeMixins from './mixins/spent-time-show.js'
export default {
  name: 'mentee-feedback3',
  props: ['appDetail'],
  mixins: [errorMixins, SpendTimeMixins],
  components: {
    Editor,
    SpendTime,
    FeedbackTitle
  },
  data () {
    return {
      promptInput,
      formValidate: {
        projectInfo: ['']
      },
      ruleValidate: {
        highlights: [{ required: true, message: promptInput }],
        homework: [{ required: true, message: promptInput }],
        timeSpent: [{ required: true, message: promptInput }, { validator: validateNumber }]
      },
      isSub: false,
      remainTime: {}
    }
  },
  computed: {},
  mounted () {
  },
  methods: {
    // 提交feedback
    handleSend () {
      this.$refs['formValidate'].validate((valid) => {
        console.log(valid)
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.formValidate))
          data.appointmentId = this.appDetail.id
          this.makeProjectInfo(data)
          this.isSub = true
          console.log(data)
          this.$emit('on-feedback', data)
        }
      })
    },
    // 执行完成
    handleComplete () {
      this.isSub = false
    },
    makeProjectInfo (data) {
      let obj = {}
      data.projectInfo.forEach((item, index) => {
        obj['essay' + (index + 1)] = item
      })
      data.projectInfo = obj
    },
    // 增加essay
    handleAddEssay () {
      this.formValidate.projectInfo.push('')
    },
    // 删除essay
    handleDeleteEssay (index) {
      this.formValidate.projectInfo.splice(index, 1)
    }
  }
}
</script>
<style lang='less' scoped>
</style>
